const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/workflows/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/_settingsLayout/settings/workflows")({
  beforeLoad: ({
    context
  }) => {
    const currentCommunity = context.punditUserContext?.currentCommunity;
    if (!currentCommunity?.workflows_enabled) {
      redirect({
        to: "/settings",
        throw: true
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});